document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.s-winning-team');
    if (!root) return;

    const stageId = root.dataset.stageId;
    const closeBtn = root.querySelector('.js-winning-team-close');
    if (!stageId || !closeBtn) return;

    closeBtn.addEventListener('click', async () => {
        root.classList.add('is-closing');

        try {
            await fetch(`/stage-winner/seen/${stageId}`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
        } catch (_) {
            // Network failure: popup still closes locally; will re-appear on next visit.
        }

        setTimeout(() => root.remove(), 250);
    });
});
